import React, {useState} from "react";
import auth from "../../utils/Auth";
import {Button, TextField} from "@mui/material";
import {Link} from 'react-router-dom';
import {Link as MuiLink} from '@mui/material';
import {useSnackbar} from 'notistack';
import Grid from '@mui/material/Grid';
import FormWrapper from "../../components/PaperFormWrapper/PaperFormWrapper";


export const LoginContainer = () => {
    const {enqueueSnackbar} = useSnackbar();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    // TODO: Implement error toast
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleEmailInput = event => {
        setEmail(event.target.value)
        setError(false)
    };

    const handlePasswordInput = event => {
        setPassword(event.target.value);
        setError(false);
    };

    const handleLogin = async event => {
        event.preventDefault();
        setLoading(true);
        setError(false);
        const ts = Math.round(new Date().getTime() / 1000);
        const exp = ts + (24 * 3600);
        await auth.login({username: email.toLowerCase(), password, exp})
            .catch(err => {
                    setLoading(false);
                    setError(true);
                    setErrorMessage(err.toString())
                    enqueueSnackbar(err.toString(), {
                        preventDuplicate: true,
                        variant: 'error',
                        anchorOrigin: {horizontal: 'right', vertical: 'bottom'}
                    })
                }
            );
    };

    return (
        //<FormWrapper title="Login" titleLinkTo={"/login/new-user"} titleLinkLabel="Don't have an account?"
        <FormWrapper title="Login"
                     loading={loading} onSubmit={handleLogin}>
            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                type="email"
                onChange={handleEmailInput}
            />
            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                onChange={handlePasswordInput}
            />
            <Grid container pt={2}>
                <Grid item>
                    <MuiLink component={Link} to="/login/forgot-password"
                             style={{fontSize: '.875rem', 'textDecoration': 'none'}}>
                        Forgot password?
                    </MuiLink>
                </Grid>
            </Grid>
            <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={loading || (email === '' || password === '')}
                sx={{mt: 3}}
            >
                Login
            </Button>
        </FormWrapper>
    )
}